import React from 'react';
import { muiPalette } from './muiPalette';
import { alertClasses } from '@mui/material/Alert';
import { createTheme } from '@mui/material/styles';
import { muiTypography } from './muiTypography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const { spacing } = createTheme();

const filledStyle = {
  color: muiPalette.palette.primary.contrastText,
  fontWeight: muiTypography.typography.fontWeightMedium,
  [`& .${alertClasses.action}`]: {
    color: muiPalette.palette.primary.contrastText,
    '& .MuiIconButton-root': {
      '&:hover': {
        color: muiPalette.palette.primary.contrastText
      }
    }
  }
};

export const alertOverride = {
  MuiAlert: {
    styleOverrides: {
      root: ({ ownerState }) => ({
        ...(ownerState.variant !== 'outlined' && {
          border: 'none'
        }),
        ...muiTypography.typography.body2,
        display: 'flex',
        padding: spacing(0, 2)
      }),
      standard: ({ ownerState }) => ({
        backgroundColor: muiPalette.palette[ownerState.severity].light
      }),
      outlined: ({ ownerState }) => ({
        border: `1px solid ${muiPalette.palette[ownerState.severity].main}`
      }),
      filled: ({ ownerState }) => ({
        ...filledStyle,
        backgroundColor:
          ownerState.severity === 'info'
            ? muiPalette.palette.info.dark
            : muiPalette.palette[ownerState.severity].main,
        [`& .${alertClasses.message}`]: {
          color: muiPalette.palette.primary.contrastText
        },
        [`& .${alertClasses.icon}`]: {
          color: muiPalette.palette.primary.contrastText
        }
      }),
      message: {
        color: muiPalette.palette.text.primary
      },
      action: ({ ownerState }) => ({
        color: muiPalette.palette[ownerState.severity].main,
        '& .MuiIconButton-root': {
          '&:hover': {
            color: muiPalette.palette[ownerState.severity].dark
          }
        }
      }),
      icon: ({ ownerState }) => ({
        fontSize: '20px',
        padding: spacing(1, 0),
        color: muiPalette.palette[ownerState.severity].main
      })
    },
    defaultProps: {
      iconMapping: {
        success: <CheckCircleOutlineIcon fontSize="inherit" />
      }
    }
  }
};
